/* eslint-disable react-hooks/rules-of-hooks */
import React, { Children } from 'react';
import * as S from './Filters.styles';

const FiltersChilds = ({ children, setFilter, filters }) =>
  Children.toArray(children).map((child, index) => (
    <S.FiltersWrapper key={`filter-container-${index}`}>
      {child.props.filterValue
        ? child
        : React.cloneElement(child, {
            setFilterValue: setFilter(child.props.name),
            filterValue: filters[child.props.name]?.value,
          })}
    </S.FiltersWrapper>
  ));

export default FiltersChilds;
